import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { addGoogleMapsApi } from './assets/scripts/injectScripts.js';

if (environment.production) {
  enableProdMode();
}

addGoogleMapsApi(environment.googleMapsApiKey);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
